import { CarbonBudgetOutput } from '@/types';
import { Content, H2, Inline, InlineItem, Stack } from '@kinesis/bungle';
import { BudgetIndicator } from './budget-indicator';

const BudgetIndicators = (props: BudgetIndicatorsProps) => {
  const { budget } = props;
  return (
    <Content overflow='visible' padding='none' alignX='stretch'>
      <Stack space='medium'>
        <Stack space='xsmall'>
          <H2>Remaining carbon budget at 2050</H2>
        </Stack>

        <Inline>
          <InlineItem sizing='fill-container'>
            <BudgetIndicator
              policy='current'
              unit={budget.unit}
              value={budget.current}
            />
          </InlineItem>
          <InlineItem sizing='fill-container'>
            <BudgetIndicator
              policy='intermediate'
              unit={budget.unit}
              value={budget.intermediate}
            />
          </InlineItem>
          <InlineItem sizing='fill-container'>
            <BudgetIndicator
              policy='aggressive'
              unit={budget.unit}
              value={budget.aggressive}
            />
          </InlineItem>
        </Inline>
      </Stack>
    </Content>
  );
};

export type BudgetIndicatorsProps = {
  budget: CarbonBudgetOutput;
};
export { BudgetIndicators };
